<template>
	<div>
		<div class="form-group row mb-4">
			<label class="col-xl-3 col-lg-3 col-form-label text-right">{{ category.name }}</label>

			<div class="col-xl-9 col-lg-9 dm-checkbox-email-options checkbox-list" v-if="taxonomiesList">
				<label class="checkbox font-weight-bolder" :class="partiallySelectedClass" >
					<input type="checkbox" checked="checked" v-model="allButtonChecked" @change="toggleAll()">
					<span></span>All
				</label>
				<label class="checkbox" v-for="taxonomy in taxonomiesList" :key="'taxonomy-' + taxonomy.id">
					<input type="checkbox" :value="taxonomy.id" v-model="preferences[taxonomyType]" @change="handleChange()">
					<span></span>{{ taxonomy.name }}
				</label>
			</div>
		</div>

		<div class="separator separator-dashed my-10"></div>
	</div>

</template>

<script>

export default {

	props: ['category', 'preferences'],

	computed: {
		taxonomiesList() {
			if (this.category.sub_categories) 
				return this.category.sub_categories;
			if (this.category.genres) 
				return this.category.genres;
			return [];
		},
		taxonomyType() {
			if (this.category.sub_categories) 
				return 'sub_categories';
			if (this.category.genres) 
				return 'genres';
			return '';
		},
		taxonomyIds() {
			return this.taxonomiesList.map(a => a.id);
		},
		existingPreferences() {
			return this.preferences[this.taxonomyType];
		},
		allValues() {
			let mergedArrays = this.existingPreferences.concat(this.taxonomyIds);
			
			let uniqueArray = mergedArrays.filter(function(item, pos, self) {
				return self.indexOf(item) == pos;
			})

			return uniqueArray;
		},
		allSelected() {
			return this.difference(this.taxonomyIds, this.existingPreferences).length == 0;
		},

		partiallySelected() {
			let differenceLength = this.difference(this.taxonomyIds, this.existingPreferences).length;
			return differenceLength > 0 && differenceLength < this.taxonomyIds.length;
		},

		partiallySelectedClass() {
			if (this.partiallySelected)
				return 'checkbox-outline checkbox-outline-2x';
			return '';
		},
		allButtonChecked() {
			return this.allSelected || this.partiallySelected;
		},
		uniqueOutsideTaxonomies() {
			return this.difference(this.existingPreferences, this.taxonomyIds);
		},

		currentCategoryPositionInPreferences() {
			return this.preferences.categories.indexOf(this.category.id);
		}
	},
	methods: {
		toggleAll() {
			if (this.allSelected)
				return this.removeAll();
			return this.addAll();
		},
		addAll() {
			this.preferences[this.taxonomyType] = this.allValues;
			this.handleChange();
		},
		removeAll() {
			this.preferences[this.taxonomyType] = this.uniqueOutsideTaxonomies;
			this.handleChange();
		},
		difference(a1, a2) {
			var result = [];
			for (var i = 0; i < a1.length; i++) {
				if (a2.indexOf(a1[i]) === -1) {
					result.push(a1[i]);
				}
			}
			return result;
		},
		handleChange() {
			this.$emit('changesMade');
			this.setCategories();
		},
		setCategories() {
			if (this.allButtonChecked && !this.preferences.categories.includes(this.category.id))
				this.addCurrentCategoryToPreferences();

			if (!this.allButtonChecked) {
				this.removeCurrentCategoryFromPreferences();
			}
		},
		addCurrentCategoryToPreferences() {
			this.preferences.categories.push(this.category.id);
		},
		removeCurrentCategoryFromPreferences() {
			this.preferences.categories.splice(this.currentCategoryPositionInPreferences, 1);
		}
	}
}
</script>
